var exports = {
  "w": "xfd349460--8efa34--header",
  "a": "xfd349460--8efa34--slider",
};

module.exports = exports;
